import { useContext } from 'react';

import { AuthContext, type AuthContextValue } from '@/providers/AuthProvider.context';

/**
 * Returns the active authentication context.
 */
export function useAuth(): AuthContextValue {
    const context = useContext(AuthContext);

    if (!context) {
        throw new Error('useAuth must be used within AuthProvider');
    }

    return context;
}
